// package imports
import React from 'react';

// CSS imports
import './SectionWrapper.css';

// Type imports
import { SectionContentSize } from '../../../types/sectionWrapper/SectionContentSize';

type Props = {
  children?: React.ReactNode;
  contentWidth?: SectionContentSize;
  backgroundColor?: string;
  className?: string;
};

const SectionWrapper: React.FC<Props> = ({
  children,
  contentWidth,
  backgroundColor,
  className,
}) => {
  return (
    <section
      className={`SectionWrapper ${className ? className : ''}`}
      style={{ backgroundColor: backgroundColor ? backgroundColor : undefined }}
    >
      <div
        className={`section-content ${
          contentWidth === SectionContentSize.SMALL
            ? 'small-wrapper'
            : contentWidth === SectionContentSize.MEDIUM
            ? 'medium-wrapper'
            : contentWidth === SectionContentSize.FULL_SCREEN
            ? 'full-screen-wrapper'
            : ''
        }`}
      >
        {children ? children : null}
      </div>
    </section>
  );
};

export default SectionWrapper;
